<template>
  <v-form
    @submit.prevent="subscribe()"
    class="news-letter-form"
  >
    <div class="news-letter-form__title">{{ $t('FOOTER.TITLE') }}</div>
    <div
      class="news-letter-form__body"
      v-html="$t('FOOTER.BODY')"
    ></div>
    <div class="news-letter-form__actions mt-3">
      <div class="news-letter-form__input">
        <InputBlack
          :label="$t('FOOTER.ACTION_EMAIL')"
          v-model="email"
          type="email"
          required

          :error-messages="errors.email"
        />
      </div>
      <div class="news-letter-form__btn">
        <Btn type="submit" :loading="subscribeState.loading">{{ $t('FOOTER.ACTION_SUBMIT') }}</Btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import Btn from '../../base/Btn/Btn'
import InputBlack from '../../base/Input/InputBlack.vue'
import { useFormAction } from '../../../utils/Promis'

export default {
  name: 'NewsletterForm',
  components: { InputBlack, Btn },
  data () {
    return {
      email: null,
      errors: {},
      subscribeState: {
        loading: false,
        data: null
      }
    }
  },
  methods: {
    async subscribe () {
      const payload = { email: this.email, type: 'buyer' }
      this.errors = this.errors = {}

      this.subscribeState = useFormAction( async ()=>{
        try {
          await this.$axios.post('newsletter', payload)
          this.$app.toast(this.$t('COMMON.SUBSCRIBE_SUCCESS'), 5000)
          this.email = null
        } catch (error) {
          if (error.status === 422 && error.data) {
            this.errors = error.data.errors
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: "Turbinado Bold";
  src: url("./turbinado.otf") format("opentype");
}

.news-letter-form {
  &__title {
    font-family: 'Turbinado Bold', serif;
    font-size: 34px;
  }

  &__body {
    max-width: 600px;
  }

  &__actions {
    display: flex;
    align-items: flex-start;

  }

  &__input {
    flex: 1;
    max-width: 500px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
}
</style>
